import React, { type InputHTMLAttributes } from "react";

import classNames from "classnames";

import { ReactComponent as CloseIcon16 } from "../../assets/icons/CloseIcon16.svg";

import style from "./TextField.module.css";

export type TextFieldProps = {
  error?: boolean;
  errorMessage?: string;
  clearable?: boolean;
  onClear?: () => void;
};

export const TextField = React.forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & TextFieldProps
>(({ error, errorMessage, clearable = false, onClear, ...attrs }, ref) => {
  return (
    <div className={classNames(style.wrapper, attrs.className)}>
      <div className={classNames(style.inputWrapper, (error || errorMessage) && style.error)}>
        <input
          type="text"
          {...attrs}
          ref={ref}
          className={classNames(
            style.textField,
            (error || errorMessage) && style.error,
            clearable && style.clearableTextField
          )}
        />
        {clearable && (
          <CloseIcon16
            className={classNames(style.closeIcon)}
            onClick={() => onClear && onClear()}
          />
        )}
      </div>
      {errorMessage && <span className={style.errorMessage}>{errorMessage}</span>}
    </div>
  );
});

TextField.displayName = "TextField";
